// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_uPB","cls2":"AuthorHeader-cls2_zOP AuthorHeader-cls1_uPB"};